import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { StatsBar } from '../components/StatsBar';
import { WhyLatam } from '../components/WhyLatam';
import { HiringChallenges } from '../components/HiringChallenges';
import { WhyTalvori } from '../components/WhyTalvori';
import { HowItWorks } from '../components/HowItWorks';
import { Roles } from '../components/Roles';
import { Testimonials } from '../components/Testimonials';
import { About } from '../components/About';
import { TalentWithPurpose } from '../components/TalentWithPurpose';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white" data-id="element-332">
      <Navigation data-id="element-333" />
      <main data-id="element-334">
        <Hero data-id="element-335" />
        <StatsBar data-id="element-336" />
        <WhyLatam data-id="element-337" />
        <HiringChallenges data-id="element-338" />
        <WhyTalvori data-id="element-339" />
        <HowItWorks data-id="element-340" />
        <Roles data-id="element-341" />
        <Pricing data-id="element-342" />
        <Testimonials data-id="element-343" />
        <About data-id="element-344" />
        <TalentWithPurpose data-id="element-345" />
        <FAQ data-id="element-346" />
        <FinalCTA data-id="element-347" />
      </main>
      <Footer data-id="element-348" />
    </div>;
}